import { halfPageManagerState as state } from './halfPageManagerState';
import * as consts from './halfPageManagerConstants';

export const halfPageManagerInsertRepeaters = (): void => {
  const spotToInsert: HTMLElement | undefined = state.getElementToInsertRepeaterInto();
  const asideRootMiniplayer: HTMLElement | null = document.querySelector('aside > .miniplayer');

  if (spotToInsert) {
    // Vložíme počet bannerů dle výšky obsahu do elementu ke vložení
    for (let i = 0; i < state.getRepeaterBannerInsertCount(); i += 1) {
      spotToInsert.insertAdjacentHTML('beforeend', consts.REPEATER_CONTENT);

      // Právě vložený banner si uložíme do arraye s repeatery pro jeho snadnou manipulaci
      const currentBanners: NodeListOf<HTMLElement> = spotToInsert.querySelectorAll(
        '.sidebar-content--repeater'
      );
      const newBanner: HTMLElement = currentBanners[currentBanners.length - 1];
      state.pushToRepeaterBannerList(newBanner);

      // Zavoláme inicializaci reklamy na právě vložený banner;
      window.__cncAdsQueue = window.__cncAdsQueue || [];
      window.__cncAdsQueue.push(() => {
        window.__cncLazyLoad(newBanner.querySelector('.cnc_side_ad_position'));
      });
    }

    // Vynulujeme počet vkládaných bannerů, pro předcházení opakovanému vkládání
    state.setRepeaterBannerInsertCount(0);
  }

  // Pokud je přímo v aside prvku miniplayer, přesuneme ho do prvního banneru
  // Kvůli spojenému sticky scrollování navíc musíme prvky vložit do extra wrapperu
  if (asideRootMiniplayer && state.getRepeaterBannerList().length) {
    const firstBannerContent: string = state.getRepeaterBannerList()[0].innerHTML;
    const wrapper: HTMLElement = document.createElement('div');
    wrapper.classList.add('sidebar-content__slider-wrapper');

    state.getRepeaterBannerList()[0].innerHTML = '';
    state.getRepeaterBannerList()[0].prepend(wrapper);
    wrapper.prepend(asideRootMiniplayer);
    wrapper.insertAdjacentHTML('beforeend', firstBannerContent);
  }
};
